import {GatsbyBrowser} from 'gatsby'

import fontLoader from '../../../shared/utils/font-loader'

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
    fontLoader()
}
